import { accessNodeId } from "./catalog";

const TRACKING = "rastreo-telemetria";

const adminNode = (sectionId: string): string =>
  accessNodeId(TRACKING, "admin", sectionId);

const liteNode = (sectionId: string): string =>
  accessNodeId(TRACKING, "lite", sectionId);

export const ACCESS_NODES = {
  adminDevices: adminNode("devices"),
  adminDrivers: adminNode("drivers"),
  adminGeofences: adminNode("geofences"),
  adminGroups: adminNode("groups"),
  adminSessions: adminNode("sessions"),
  adminTrailers: adminNode("trailers"),
  adminTrips: adminNode("trips"),
  adminUnits: adminNode("units"),
  adminUsers: adminNode("usuarios"),
  liteActions: liteNode("actions"),
  liteDriver: liteNode("driver"),
  liteFootprint: liteNode("footprint"),
} satisfies Record<string, string>;

export type AccessNodeKey = keyof typeof ACCESS_NODES;
